var _mask, _g, _mask2, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKnife = function SvgKnife(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "knife_svg__a",
    width: 14,
    height: 13,
    x: 2,
    y: 21,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 21.008h13.962V33.7H2z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#knife_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "m15.962 23.845-8.948 8.952a3.08 3.08 0 0 1-4.355 0L2 32.139l11.126-11.13z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "knife_svg__b",
    width: 22,
    height: 22,
    x: 13,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.135 2.97h20.87v20.875h-20.87z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#knife_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M20.609 20.755 34.005 7.36 29.616 2.97 16.59 15.996a15.7 15.7 0 0 0-2.72 3.66l-.734 1.362 2.827 2.827 1.82-.985a12.2 12.2 0 0 0 2.827-2.105",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "m26.156 12.19-1.371-1.37 6.34-6.341 1.37 1.371z",
    clipRule: "evenodd"
  })));
};
export default SvgKnife;